import createReactComponent from '../createReactComponent';
var PhoneOff = createReactComponent('PhoneOff', [['path', {
  d: 'M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7 2 2 0 011.72 2v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91',
  key: '3u1qls'
}], ['line', {
  x1: '22',
  y1: '2',
  x2: '2',
  y2: '22',
  key: '1sphze'
}]]);
export default PhoneOff;